// extracted by mini-css-extract-plugin
export var grid = "_2r-0";
export var span1 = "_2r-2";
export var span10 = "_2r-b";
export var span10L = "_2r-z";
export var span10M = "_2r-n";
export var span10Xl = "_2r-1b";
export var span11 = "_2r-c";
export var span11L = "_2r-10";
export var span11M = "_2r-o";
export var span11Xl = "_2r-1c";
export var span12 = "_2r-d";
export var span12L = "_2r-11";
export var span12M = "_2r-p";
export var span12Xl = "_2r-1d";
export var span1L = "_2r-q";
export var span1M = "_2r-e";
export var span1Xl = "_2r-12";
export var span2 = "_2r-3";
export var span2L = "_2r-r";
export var span2M = "_2r-f";
export var span2Xl = "_2r-13";
export var span3 = "_2r-4";
export var span3L = "_2r-s";
export var span3M = "_2r-g";
export var span3Xl = "_2r-14";
export var span4 = "_2r-5";
export var span4L = "_2r-t";
export var span4M = "_2r-h";
export var span4Xl = "_2r-15";
export var span5 = "_2r-6";
export var span5L = "_2r-u";
export var span5M = "_2r-i";
export var span5Xl = "_2r-16";
export var span6 = "_2r-7";
export var span6L = "_2r-v";
export var span6M = "_2r-j";
export var span6Xl = "_2r-17";
export var span7 = "_2r-8";
export var span7L = "_2r-w";
export var span7M = "_2r-k";
export var span7Xl = "_2r-18";
export var span8 = "_2r-9";
export var span8L = "_2r-x";
export var span8M = "_2r-l";
export var span8Xl = "_2r-19";
export var span9 = "_2r-a";
export var span9L = "_2r-y";
export var span9M = "_2r-m";
export var span9Xl = "_2r-1a";
export var stretch = "_2r-1";